export default {
  RegistrationByInviteLinkPage: {
    title: 'Create account',
    label: {
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
    },
    btn: {
      submit: 'Sign Up',
    },
  },
};
